import { CircularProgress, Typography } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Dialog } from "@material-ui/core";
import { DialogActions } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";
import { DialogContentText } from "@material-ui/core";
import { DialogTitle } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Snackbar } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { ErrorModal } from "../../../../../components/modals/error-modal";
import MesfModal from "../../../../../components/modals/modal.mesf";
import { LazyLoading } from "../../../../../controls/LazyLoading/LazyLoading";
import { Alert } from "../../../../../controls/alert";
import { Profile } from "../../models/Profile";
import { deleteProfile } from "../../repositories/ProfilesRepository";

type Props = {
	profile: Profile | null;
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
};

export const DeleteProfile = ({ profile, show, onHide }: Props) => {
	const [open, setOpen] = useState(false);
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState(true);
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [deleteAlert, setDeleteAlert] = useState(false);

	const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}
		setOpen(false);
		setDeleteAlert(false);
	};

	useEffect(() => {
		if (show) {
			setIsLoading(false);
			setIsSubmitLoading(false);
		}
	}, [show]);

	const onDelete: (data: number) => Promise<void> = async (data: number) => {
		setIsSubmitLoading(true);
		const res = await deleteProfile(data as number);
		if (res.ok) {
			setDeleteAlert(false);
			setOpen(true);
			onHide(true);
			setIsSubmitLoading(false);
		} else {
			setError(res.message), setIsSubmitLoading(false);
		}
	};

	return (
		<>
			<MesfModal
				title="DELETE PROFILE"
				open={show}
				handleClose={() => onHide(false)}
				id="delete-profile-modal"
				maxWidth="md"
			>
				<form>
					<MesfModal.Content style={{ padding: "15px 30px" }}>
						{isLoading && (
							<Grid
								container
								justifyContent="center"
								alignItems="center"
								style={{ minHeight: "150px" }}
							>
								<LazyLoading />
							</Grid>
						)}
						{!isLoading && (
							<>
								<Grid container spacing={1}>
									<Grid item md={12} xs={12}>
										<Typography>
											Are you sure you want to delete{" "}
											<strong>{profile?.ProfileName}</strong> profile?
										</Typography>
									</Grid>
								</Grid>
							</>
						)}
					</MesfModal.Content>
					<MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
						<Grid container spacing={2} justifyContent="flex-end">
							<Grid item md={3} xs={12} style={{ margin: 0 }}>
								<Button
									fullWidth
									variant="contained"
									color="default"
									onClick={() => onHide(false)}
								>
									Cancel
								</Button>
							</Grid>
							<Grid item md={3} xs={12} style={{ margin: 0 }}>
								<Button
									fullWidth
									variant="contained"
									color="secondary"
									onClick={() => setDeleteAlert(true)}
								>
									DELETE
								</Button>
							</Grid>
						</Grid>
					</MesfModal.Actions>
					<Dialog
						open={deleteAlert}
						onClose={() => handleClose()}
						aria-labelledby="responsive-dialog-title"
					>
						<DialogTitle id="responsive-dialog-title">{"WARNING"}</DialogTitle>
						<DialogContent>
							<DialogContentText style={{ padding: 0, margin: 0 }}>
								Be careful, once deleted you will not be able to recover this
								profile, are you sure you want to delete it?
							</DialogContentText>
						</DialogContent>
						<DialogActions style={{ padding: "16px 24px" }}>
							<Button
								onClick={() => setDeleteAlert(false)}
								autoFocus
								color="default"
							>
								CANCEL
							</Button>
							<Button
								startIcon={isSubmitLoading && <CircularProgress size="1rem" />}
								autoFocus
								color="secondary"
								onClick={() => onDelete(profile?.ProfileId as number)}
							>
								Delete
							</Button>
						</DialogActions>
					</Dialog>
				</form>
			</MesfModal>
			<Snackbar open={open} autoHideDuration={2500} onClose={handleClose}>
				<Alert severity="success" onClose={handleClose}>
					The profile was deleted successfully
				</Alert>
			</Snackbar>
			<ErrorModal
				error={error}
				onHide={() => setError("")}
				title="Error Deleting Profile"
			/>
		</>
	);
};
